import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import { yup } from "utils";

import { validationSchema } from "../AddUserModal/components/NewUserInfoPage/hooks/useNewUserInfoForm";

export function useUserForm(allRequired = true) {
  return useForm({
    mode: "onBlur",
    resolver: yupResolver(yup.object(validationSchema(allRequired))),
  });
}

export default useUserForm;
